import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { BRAND, IMAGES } from "@/data";
import { ValuationForm } from "@/components/ValuationForm";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-28 pb-16 sm:pt-32 lg:pt-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        {/* Left copy */}
        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 overline text-kw-red mb-6"
          >
            <MapPin size={14} /> {BRAND.city} · Real Estate
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.05 }}
            className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-kw-ink"
          >
            Get the most money,
            <br />
            in the <span className="text-kw-red italic">least time</span>,
            <br />
            with the least stress.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-7 max-w-xl text-base sm:text-lg text-neutral-600 leading-relaxed"
          >
            Our proven system replaces months of uncertainty with a strategic, repeatable plan.
            Whether you're buying or selling in Denver, you'll always know the next move.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.35 }}
            className="mt-9 flex flex-wrap items-center gap-6"
          >
            <a
              href="#services"
              data-testid="hero-explore-cta"
              className="border border-kw-ink px-7 py-3.5 text-sm font-semibold tracking-wide hover:bg-kw-ink hover:text-white transition-colors duration-300"
            >
              How The System Works
            </a>
            <div className="flex items-center gap-3">
              <img src={BRAND.headshot} alt="Brett Weller" className="w-11 h-11 object-cover grayscale" />
              <div className="leading-tight">
                <p className="text-sm font-semibold text-kw-ink">{BRAND.name}</p>
                <p className="text-xs text-neutral-500">{BRAND.brokerage}</p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Right form */}
        <motion.div
          initial={{ opacity: 0, y: 36 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="lg:col-span-5"
        >
          <ValuationForm />
        </motion.div>
      </div>

      {/* Skyline strip */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.4 }}
        className="max-w-7xl mx-auto px-5 sm:px-8 mt-14"
      >
        <div className="relative h-48 sm:h-64 overflow-hidden">
          <img src={IMAGES.hero} alt="Denver skyline" className="w-full h-full object-cover object-center" />
          <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent" />
        </div>
      </motion.div>
    </section>
  );
};
